import { compose } from 'lodash/fp'
import RoomLimitsExceededModal from './RoomLimitsExceededModal'
import withState from './withState'

export default compose(withState)(RoomLimitsExceededModal)
